module.exports = __webpack_public_path__ + "static/pakmaya-gida-guvenligi-769a49016cf05f838c5e31b0eadc264c.png";